import React, { useState } from 'react';
import { Link, router } from '@inertiajs/react';
import './Workspace.css';

/**
 * SRS v0 — pick a script (or resume a workspace).
 * Props from SrsController@index.
 */
export default function Pick({ movies, projects, is_admin }) {
  const [hash, setHash] = useState('');

  const openHash = (e) => {
    e.preventDefault();
    const h = hash.trim();
    if (h) router.get(`/srs/open/${encodeURIComponent(h)}`);
  };

  return (
    <div className="srs container py-4">
      <h1 className="h3 mb-1">Screenplay Revision</h1>
      <p className="text-muted mb-4">
        Pick a script. First you'll see its contract — what every scene inherits — then work scene by scene, seven steps each.
        The model reads, drafts and proposes; only you decide.
      </p>

      {projects.length > 0 && (
        <section className="mb-4">
          <h2 className="h5 srs-label mb-2">Resume a workspace</h2>
          <div className="list-group">
            {projects.map((p) => (
              <Link key={p.uuid} href={`/srs/p/${p.uuid}/contract`} className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
                <span>
                  <strong>{p.title || p.movie_hash}</strong>
                  <span className="text-muted ms-2 small">{p.units} units</span>
                </span>
                <span className="text-muted small">updated {p.updated}</span>
              </Link>
            ))}
          </div>
        </section>
      )}

      <section className="mb-4">
        <h2 className="h5 srs-label mb-2">Your scripts</h2>
        {movies.length === 0 ? (
          <p className="text-muted">No scripts on this account yet.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead>
                <tr>
                  <th scope="col">Title</th>
                  <th scope="col" className="text-end">Scenes</th>
                  <th scope="col">Submitted</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {movies.map((m) => (
                  <tr key={m.hash}>
                    <td>{m.title || <span className="text-muted">(untitled)</span>}</td>
                    <td className="text-end">{m.scenes}</td>
                    <td className="text-muted">{m.created || ''}</td>
                    <td className="text-end">
                      <Link href={`/srs/open/${encodeURIComponent(m.hash)}`} className="btn btn-sm btn-primary">Open</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>

      {is_admin && (
        <section className="mb-4">
          <h2 className="h5 srs-label mb-2">Open any script by hash</h2>
          <form className="d-flex gap-2" onSubmit={openHash} style={{ maxWidth: 520 }}>
            <input className="form-control" value={hash} onChange={(e) => setHash(e.target.value)} placeholder="movie hash" />
            <button className="btn btn-outline-primary" type="submit">Open</button>
          </form>
        </section>
      )}
    </div>
  );
}
